<template>
  <div class="watch">
    <v-container>
      <v-btn text @click="back">
        <v-icon left>mdi-arrow-left</v-icon>
        一覧に戻る
      </v-btn>
      <div :style="{ width: playerWidth + 'px', height: playerHeight + 'px' }" class="pt-3">
        <video-player
          v-if="accessToken"
          class="px-6"
          el="player"
          ref="player"
          :options="options"
        ></video-player>
      </div>
      <v-card flat class="mx-6 transparent">
        <v-card-title class="pl-0 my-1">
          {{ video.title }}
        </v-card-title>
        <v-card-subtitle class="pl-0">
          {{ video.created_at | moment }} 作成
        </v-card-subtitle>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="getAttachment" :loading="loading">添付資料ダウンロード</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment"
import VideoPlayer from "@/components/VideoPlayer";

export default {
  components: {
    VideoPlayer
  },
  props: ['uuid'],
  data() {
    return {
      windowWidth: window.innerWidth,
      apiPath: `/api/videos/${this.$route.params.id}`,
      video: {},
      loading: false,

      accessToken: null,
    };
  },
  created () {
    this.fetch();
  },
  mounted: function () {
    window.addEventListener('resize', this.calculateWindowWidth);
    this.$auth.getTokenSilently().then((token) => {
      this.accessToken = token
    }).finally(() => {
      this.$refs.player.init();
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateWindowWidth);
  },
  computed: {
    playerHeight: function () {
      return this.playerWidth * 9 / 16
    },
    playerWidth: function () {
      if (this.windowWidth > 1280) {
        return 1280
      } else if (this.windowWidth < 427) {
        return 427
      } else {
        return this.windowWidth;
      }
    },
    options: function() {
      return {
        source: `/v/${this.uuid}/hls/video.m3u8?t=${this.accessToken}`,
        poster: `/v/${this.uuid}/thumb`,
        width: '100%',
        height: '100%',
        autoplay: false,
        watermark: {}
      }
    }
  },
  filters: {
    moment(value) {
      return moment(value).format('YYYY/MM/DD HH:mm:ss');
    },
  },
  methods: {
    async fetch () {
      const accessToken = await this.$auth.getTokenSilently()
      axios.get(`/api/video/${this.uuid}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
      }).then(response => {
        this.video = response.data
      }).catch(error => {
        console.log(error)
      })
    },
    calculateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    getFileNameFromContentDisposition(disposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/; // 正規表現でfilenameを抜き出す
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        const fileName = matches[1].replace(/['"]/g, '');
        return decodeURI(fileName) // 日本語対応
      } else {
        return null
      }
    },
    async getAttachment() {
      this.loading = true
      const accessToken = await this.$auth.getTokenSilently();
      axios
        .get(`/v/${this.uuid}/attachment`, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          responseType: 'blob'
        })
        .then(response => {
          const url = URL.createObjectURL( new Blob([response.data]), {type: response.headers['content-type']});
          const filename = this.getFileNameFromContentDisposition(response.headers['content-disposition'])

          const link = document.createElement("a");
          link.href = url;
          link.download = filename
          link.click();
          URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        });
    },
    back() {
      this.$router.push({name:'List'})
    },
  }
};
</script>

<style scoped>
.watch {
  background-color: #EEEEEE;
  height: 100%;
}
#player {
  width: 100%;
  height: 100%;
}
</style>
